const faqs = [
  {
    q: '6080影视的动漫资源真的完全免费吗？',
    a: '是的，6080影视所有动漫番剧均完全免费在线观看，无需注册、无需登录、无需付费订阅。我们致力于为动漫迷提供最纯粹、无障碍的追番体验。',
  },
  {
    q: '观看动漫需要安装播放器或插件吗？',
    a: '不需要。6080影视采用先进的H5播放技术，直接通过浏览器即可观看全部动漫资源，无需安装任何播放器、插件或APP即可享受高清流畅播放。',
  },
  {
    q: '为什么选择6080影视而不是其他平台？',
    a: '6080影视主打"不缓冲 + 高清画质 + 完全免费"三大核心优势。我们使用智能CDN加速引擎确保1080P片源流畅播放，每周同步更新最新番剧，同时坚持零门槛免费观看，是动漫迷追番的最佳选择。',
  },
  {
    q: '有哪些动漫类型和分类？',
    a: '平台覆盖日漫、国漫、经典番剧等大类，细分热血战斗、恋爱喜剧、悬疑推理、异世界穿越、治愈日常、剧场版等多种类型。动漫大全涵盖新番、完结番、经典老番，满足各类动漫迷的需求。',
  },
  {
    q: '更新频率如何？新番多久能上线？',
    a: '6080影视每周更新50+部动漫番剧，热门新番一般在日本播出后数小时内即可上线中文资源。所有链接实时维护，确保追番体验不间断。',
  },
];

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">常见问题</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">关于6080影视，你想知道的都在这里</p>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="rounded-xl bg-background-50 border border-background-200/70 p-4 md:p-5 transition-colors hover:border-primary-200">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 font-heading text-lg flex-shrink-0">Q{i + 1}</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}